import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
const offers = [{
  id: 1,
  title: 'Summer Getaway Sale',
  description: 'Save up to 30% on selected hotels worldwide for your summer vacation.',
  code: 'SUMMER30',
  validUntil: 'August 31, 2023',
  image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2073&q=80'
}, {
  id: 2,
  title: 'City Break Deals',
  description: 'Get 15% off flight + hotel packages to top city destinations.',
  code: 'CITY15',
  validUntil: 'December 15, 2023',
  image: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1244&q=80'
}];
const SpecialOffers = () => {
  return <section className="py-12 bg-gray-50" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-12" data-id="element-171">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-172">Special Offers</h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-173">
            Limited time deals to help you save on your next trip
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-174">
          {offers.map(offer => <div key={offer.id} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col md:flex-row" data-id="element-175">
              <div className="md:w-2/5 h-48 md:h-auto" data-id="element-176">
                <img src={offer.image} alt={offer.title} className="w-full h-full object-cover" data-id="element-177" />
              </div>
              <div className="p-6 md:w-3/5 flex flex-col justify-between" data-id="element-178">
                <div data-id="element-179">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-180">
                    {offer.title}
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-181">{offer.description}</p>
                  <div className="mt-4 inline-block bg-blue-50 rounded px-3 py-1 text-sm font-medium text-blue-700" data-id="element-182">
                    Promo code: {offer.code}
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between" data-id="element-183">
                  <p className="text-sm text-gray-500" data-id="element-184">
                    Valid until {offer.validUntil}
                  </p>
                  <Link to="/search?type=package" data-id="element-185">
                    <Button variant="primary" size="sm" data-id="element-186">
                      Book Now
                    </Button>
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default SpecialOffers;